import React, { useEffect, useState } from 'react';
import logo from '../../../assets/owlbot_logo_login.png';
import { useNavigate } from 'react-router-dom';
import Footer from '../../../components/Footer/Footer';
import { errorMessage } from '../../../config/errorsMsg';
import axios from 'axios';
import { flashBarTheme } from '../../../config/flashBar';
import FlashBar from '../../../components/FlashBar/FlashBar';
import ActivityIndicator from '../../../components/ActivityIndicator/ActivityIndicator';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [formError, setFormError] = useState<any>({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [successDiv, setSuccessDiv] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [flashbar, setFlashbar] = useState({
    isOpen: false,
    message: '',
    type: '',
  });

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit === true) {
      sendMail();
    }
  }, [formError]);

  const validation = () => {
    const error: any = {};
    if (!email) {
      error.email = errorMessage.emptyEmail;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      error.email = errorMessage.userValidMail;
    }
    return error;
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
    if (event.target.value !== '') {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: errorMessage.emptyEmail,
      });
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleClick();
    }
  };

  const handleClick = () => {
    setFormError(validation());
    setIsSubmit(true);
  };

  const sendMail = async () => {
    setIsLoading(true);
    const obj = {
      email: email,
    };
    await axios
      .post(`${process.env.REACT_APP_API_BASEURL}/account/forget-password`, obj)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch(() => {
        setFlashbar({
          ...flashbar,
          isOpen: true,
          type: flashBarTheme.ERROR,
          message: errorMessage.oops,
        });
        setIsLoading(false);
      });
  };
  const gotResponse = (data: any) => {
    const { isSuccess, message } = data;
    if (isSuccess) {
      setSuccessDiv(true);
    } else {
      setFlashbar({
        ...flashbar,
        isOpen: true,
        type: flashBarTheme.ERROR,
        message: message ? message : 'Something went wrong',
      });
    }
    setIsLoading(false);
  };

  return (
    <>
      {isLoading ? <ActivityIndicator /> : null}
      <FlashBar
        message={flashbar.message}
        isOpen={flashbar.isOpen}
        type={flashbar.type}
        handleClose={() => {
          setFlashbar({ ...flashbar, isOpen: false });
        }}
      />
      <div className=" relative flex justify-center items-center h-screen bg-slate-100">
        {!successDiv ? (
          <div className="border w-96 h-[400px] p-8 flex flex-col justify-center shadow-lg rounded-sm bg-white">
            <img src={logo} className="w-9/12 mx-auto my-0 pb-5" />
            <div className="mb-6">
              <div className="font-semibold text-[#526D82] text-sm">
                Enter email address
              </div>
              <div className="my-1 flex items-center">
                <div className="h-8 w-12 bg-[#173959] flex items-center justify-center py-1 rounded-l-sm">
                  <i className="fa-solid fa-user text-white relative left-[2px]"></i>
                </div>

                <input
                  type="text"
                  name="email"
                  value={email}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleChange(event);
                  }}
                  onKeyDown={handleKeyDown}
                  placeholder="email"
                  className="h-8 block w-full text-sm border text-slate-500 focus:outline-none pl-2 rounded-sm"
                />
              </div>
              <div className="text-sm text-[red]">{formError.email}</div>
            </div>

            <div
              className="h-8 bg-blue-500 rounded-sm flex items-center justify-center cursor-pointer mb-2"
              onClick={() => handleClick()}
            >
              <div className="text-white font-normal p-2">SUBMIT</div>
            </div>
            <div
              className="h-8 rounded-sm flex items-center justify-center cursor-pointer"
              onClick={() => navigate('/')}
            >
              <div className="text-blue-500 font-normal p-2 text-sm">
                Back to Login
              </div>
            </div>
          </div>
        ) : (
          <div className="border w-96 h-[400px] p-8 flex flex-col justify-center shadow-lg rounded-sm bg-white">
            <div className="w-72 h-[400] flex flex-col justify-center  text-center mx-auto rounded">
              <img src={logo} className="w-9/12 mx-auto my-0 " />
              <div className="text-3xl pb-2">
                <i className="fa-solid text-[80px] fa-envelope-circle-check text-[green]"></i>
              </div>
              <div className="text-[20px] font-semibold">
                Email sent Successfully!
              </div>
              <div className="text-sm mt-4">Please check your inbox.</div>
              <div
                className="mt-4 text-[blue] cursor-pointer underline"
                onClick={() => {
                  setSuccessDiv(false), navigate('/');
                }}
              >
                Back to Login
              </div>
            </div>
          </div>
        )}

        <div className="absolute right-0 bottom-0">
          {' '}
          <Footer />
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
